import React, { useState } from "react";

import { Link } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

/// Image
import profile from "../../../images/1.jpg";
import userpro from "../../../images/ppp.png"
import avatar from "../../../images/avatar/1.jpg";
import { Dropdown } from "react-bootstrap";
import LogoutPage from './Logout';
import ChangePassword from "../../Modals/ChangePassword";
import { KeyRound } from "lucide-react";
const Header = ({ onNote }) => {
  const [changePassword, setChangePassword] = useState(false);
  const onFullScreen = () => {
    var elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  };
  return (
    <div className="navv  shadow-lg" >
      <ChangePassword password={changePassword} onHide={() => setChangePassword(false)} />
      <div className="header-content ">
        <nav className="navbar navbar-expand ">

          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">

            </div>
            <ul className="navbar-nav header-right  prof ">
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle
                  variant=""
                  as="a"
                  className="i-false c-pointer nav-link"
                  to=""
                  role="button"
                  data-toggle="dropdown"
                >
                  <div className="header-info">
                    <span>
                      <strong>Admin</strong>
                    </span>
                  </div>
                  <img src={userpro} width={20} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="right"
                  className="dropdown-menu dropdown-menu-right"
                >
                  <Link className="dropdown-item ai-icon" onClick={() => setChangePassword(true)} style={{ backgroundColor: "#fff" }}>
                    <KeyRound size={18} className="text-primary" style={{ marginRight: 10 }} />
                    <span className="ml-2">Change Password </span>
                  </Link>
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;